export default __webpack_public_path__ + "static/19-226f1d7d51b1d66b269665766e915da2.png";